<kpa-loader></kpa-loader>
<kpa-perform-audit
	[showAudit]="isAudit"
	[currentAuditId]="currentAuditId"
	[isFromPlatform]="true"
	(onClose)="closeDialog()">
</kpa-perform-audit>
